import { Moon, Sun } from "lucide-react";

import {
  resolveTheme,
  useSystemDark,
  useThemePreference,
  writePreference,
} from "../features/theme/theme";
import { cn } from "../utils/cn";

/**
 * One tap between dark and light, for every page that has a theme.
 *
 * It shows the mode a tap leads to: a sun in dark, a moon in light. It sets the
 * stored preference to that mode, so a person who had chosen "Follow phone" on
 * Profile now has an explicit choice, and the Profile switch shows it. It is on
 * every page that has a header, admin and governance included.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const [preference] = useThemePreference();
  const systemDark = useSystemDark();
  const theme = resolveTheme({ preference, systemDark });
  const next = theme === "dark" ? "light" : "dark";
  const Icon = theme === "dark" ? Sun : Moon;
  return (
    <button
      type="button"
      onClick={() => writePreference(next)}
      aria-label={`Switch to ${next} mode`}
      data-testid="theme-toggle"
      className={cn(
        "inline-flex size-11 shrink-0 items-center justify-center rounded-full text-foreground transition-colors hover:bg-foreground/10 focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring",
        className,
      )}
    >
      <Icon className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}
